import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { TikTokIcon } from "@/components/icons/TikTokIcon";
import { memo } from "react";

const CURRENT_YEAR = new Date().getFullYear();

export const Footer = memo(function Footer() {
  return (
    <footer className="py-10 bg-card border-t border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center gap-5">
          {/* Social Links */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.instagram.com/vesteiaofc"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary/20 transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
            </a>
            <a
              href="https://www.tiktok.com/@vesteiaofc"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary/20 transition-colors"
              aria-label="TikTok"
            >
              <TikTokIcon className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors" />
            </a>
          </div>

          {/* Copyright & Legal */}
          <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-3 text-sm text-muted-foreground">
            <span>© {CURRENT_YEAR} VesteIA</span>
            <span className="hidden sm:inline">•</span>
            <div className="flex items-center gap-3">
              <Link to="/termos" className="hover:text-primary transition-colors">
                Termos
              </Link>
              <Link to="/privacidade" className="hover:text-primary transition-colors">
                Privacidade
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
});
